import { render } from "./flowConfiger.vue?vue&type=template&id=17bae136"
import script from "./flowConfiger.vue?vue&type=script&lang=js"
export * from "./flowConfiger.vue?vue&type=script&lang=js"

import exportComponent from "D:\\AICodeSpace\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__